import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-16-edit",
  "use": "icon-icon-16-edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-16-edit\"><g fill=\"none\"><path d=\"M0 0h16v16H0z\" /><path d=\"M7 2a1 1 0 1 1 0 2H4v8h8V9a1 1 0 0 1 2 0v4a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4zm6.89.61a1 1 0 0 1 0 1.415L8.524 9.39H7.111V7.975l5.364-5.364a1 1 0 0 1 1.414 0z\" fill=\"#4C556C\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol